import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BUTTON_TYPES } from '../../button';
import { FormGroup } from '../form-group/form-group.class';
import { FORM_CONSTANTS } from '../form/form.constants';

@Component({
	selector: 'ea-ui-clear-form-button',
	templateUrl: './clear-form-button.component.html'
})
export class ClearFormButtonComponent {
	@Input() formName: string;
	@Input() buttonType? = BUTTON_TYPES.Secondary;
	@Input() btnText? = FORM_CONSTANTS.buttonClearText;
	@Input() form: FormGroup;
	@Output() readonly clear?: EventEmitter<void> = new EventEmitter<void>();

	resetForm(): void {
		this.form.reset();
		this.clear.emit();
	}
}
